import { Card, CardBody, Col, Collapse, Container, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Media, Row } from "reactstrap";
import { MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import _valid from "../../validations"

export default class ModalPaswword extends React.Component {

    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = {
            estadoModal: _valid(this.props.estadoModal) ? this.props.estadoModal : false,
        };
        this.salir = this.salir.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
    }

    almacenarRegistro = () => {
        let user = this.apiRest.getLS("du");
        let registro = {
            id : user.id,
            password: this.state.password1,
        }

        if (this.camposValidos()) {
            this.apiRest.put('/usuarioPasword/' + registro.id, registro).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Contraseña Cambiada Exitosamente!');
                    this.salir();
                } else if (resultado.exitoso == false) {
                    let mensajes = resultado.data.password.join('<br>');
                    toastr.error(mensajes, 'Error en la contraseña');
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    camposValidos() {
        const {
            password1,
            password2
        } = this.state;
        let estado = false;
        let texto = "Campos vacios";

        if (!_valid(password1 && password2)) {
            texto = _valid(password2) ? "Nueva Contraseña Es Requerido": texto;
            texto = _valid(password1) ? "Confirmar Contraseña Es Requerido": texto;
            toastr.error(texto);
        } else {
            if (password1 === password2) {
                estado = true;
            } else {
                toastr.error("Las contraseñas no coinciden");
            }
        }
       return estado;
    }

    salir() {
        return this.setState({ estadoModal: false });
    }

    actualizarValores = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        const {
            password1,
            password2
        } = this.state;
        return (
            <Modal isOpen={this.state.estadoModal}>
                <ModalBody>
                    <div className="p-4 border-top">
                        <Form>
                            <div>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3 mb-4">
                                            <Label htmlFor="password" className="form-label">
                                                Nueva Contraseña
                                            </Label>
                                            <Input
                                                value={password1}
                                                onChange={this.actualizarValores}
                                                name="password1"
                                                type="password"
                                                className="form-control"
                                                placeholder="Nueva  Contraseña"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3 mb-4">
                                            <Label htmlFor="password2" className="form-label">
                                                Confirmar Contraseña
                                            </Label>
                                            <Input
                                                value={password2}
                                                onChange={this.actualizarValores}
                                                name="password2"
                                                type="password"
                                                className="form-control"
                                                placeholder="Confirmar  Contraseña"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col lg={6}>
                            <MDBBtn className="bg-success-color waves-effect btn btn-rounded" color="success" onClick={() => this.almacenarRegistro()} >
                                <i className="fas fa-check" />
                            </MDBBtn> {" "}
                        </Col>
                        <Col lg={6}>
                            <MDBBtn className="bg-rojo-rosado waves-effect btn btn-rounded" color="danger" onClick={() => this.salir()} >
                                <i className="fas fa-times" />
                            </MDBBtn> {" "}
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        );
    }
}